import { staticEntityReducerTemplate } from '../reducerUtils';

export default staticEntityReducerTemplate('subcategories');



// WEBPACK FOOTER //
// ./src/reducers/entities/subcategoriesReducer.js